import { GetRequest } from "./HttpService";

export const GetDashboardData = async () => {
  const data = await GetRequest("/Dashboard/doctor-dashboard");
  return data;
};

export const GetIncomeTrend = async (granularity = "month", periods = 6) => {
  const data = await GetRequest(
    `/Dashboard/income-trend?granularity=${granularity}&periods=${periods}`
  );
  return data;
};
